import { AssetSummaryRow } from 'components/Asset/AssetSummaryRow';
import { CardRow } from 'components/CardRow';
import { Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { API_ASE_IMAGE } from 'service/api/constants';
import {
  selectAseId,
  selectAseIsOnline,
  selectAseAssetAstAseMerged,
} from 'store/assessments/selectors';
import { selectUrlToken } from 'store/auth/selectors';
import { navigateScreenAware } from 'components/Navigation/navigationRef';
import { ExplorerNavigation } from './types';

export const ExplorerAssetRow: React.FC<{
  navigation: ExplorerNavigation;
}> = () => {
  const urlToken = useSelector(selectUrlToken);
  const assessmentId = useSelector(selectAseId);
  const isOnline = useSelector(selectAseIsOnline);
  const asset = useSelector(selectAseAssetAstAseMerged);

  return (
    <CardRow
      navigationIsSelected={{
        name: Screens.ASE_ASSET,
        params: {},
      }}
      onPress={() =>
        navigateScreenAware(Stacks.ASSESSMENT, Screens.ASE_ASSET, {})
      }
    >
      <AssetSummaryRow
        remoteImageUrl={
          isOnline ? API_ASE_IMAGE(assessmentId, { urlToken }) : undefined
        }
        details={{
          name: asset.name,
          avatar: asset.avatar,
          reference: asset.reference,
          customReference: asset.customReference,
          parentName: asset.parentName,
          address1: asset.address1,
          address2: asset.address2,
          city: asset.city,
          county: asset.county,
          postcode: asset.postcode,
        }}
      />
    </CardRow>
  );
};
